import React, { useState, useEffect } from "react";
import "./SingleJobs.css";
import work from "../../../Assets/img/workSingle.svg";
import axios from "axios";
import swal from "sweetalert";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import styles from "./SingleJob.module.scss";
import { AiOutlineFieldTime } from "react-icons/ai";
import { IoLocationOutline } from "react-icons/io5";
import { BsGlobe } from "react-icons/bs";
import { TbCurrencyDollar } from "react-icons/tb";
import { useParams, useNavigate } from "react-router-dom";

function SingleJob() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [title_fa, setTitleFa] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [company, setCompany] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [document, setDocument] = useState("");
  const [apply_link, setApplyLink] = useState("");
  const [deadline, setDeadline] = useState("");
  const [salary, setSalary] = useState("");
  const [skills, setSkills] = useState([]);
  const [user, setUser] = useState([]);
  const [jobId, setJobId] = useState("");
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getUser();
    getJobData();
  }, [id]);

  const getUser = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response.data);
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  };

  const getJobData = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-job-opportunity/${id}`
      )
      .then((response) => {
        console.log(response);
        const data = response.data;

        setJobId(data._id);
        setTitle(data.title || "");
        setTitleFa(data.title_fa || "");
        setCountry(data.country || "");
        setCity(data.city || "");
        setCompany(data.company || "");
        setResponsibility(data.responsibility || "");
        setDocument(data.document || "");
        setApplyLink(data.apply_link || "");
        setSalary(data.salary || "");
        setSkills(data.skills || []);

        // محاسبه ددلاین
        if (data.deadline) {
          const oneDay = 1000 * 60 * 60 * 24;
          const today = new Date();
          const deadlineDate = new Date(data.deadline.toString());
          const differenceMs = Math.abs(today - deadlineDate);
          const days = Math.round(differenceMs / oneDay);
          setDeadline(days);
        }

        // گرفتن مهارت‌ها از API جداگانه
        axios
          .get(
            `https://arianaapp.arianaapply.com/api/V1/show-skills-job-opportunity/${id}`
          )
          .then((skillRes) => {
            console.log("skills", skillRes.data);
            const skillsData =
              skillRes.data.data?.skill || skillRes.data.data || "";
            setSkills(skillsData);
          })
          .catch((err) => {
            console.log("خطا در گرفتن مهارت‌ها:", err);
            setSkills("");
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const paymentCheck = () => {
    setLoading(true);
    axios
      .post(`https://arianaapp.arianaapply.com/api/V1/check-payment-for-apply`, {
        user_id: user._id,
        description: "aj1",
      })
      .then((res) => {
        console.log("pay", res);
        if (res.data.status === 401) {
          setLoading(false);
          navigate("/pay-job");
        } else {
          setLoading(false);
          setTimeout(() => {
            window.open(`${apply_link}`);
          }, 300);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const send = () => {
    setLoader(true);

    console.log("user_id", user, jobId);
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/check-resume", {
        user_id: user._id,
        opportunity_id: jobId,
      })
      .then((response) => {
        console.log(response);
        setLoader(false);
        if (response.data.status === 401) {
          swal({
            title: "!خطا",
            text: "شما تابحال رزومه ایجاد نکرده اید ",
            icon: "error",
            button: "!باشه",
          });
        } else {
          swal({
            title: "!انجام شد",
            text: "درخواست شما با موفقیت ارسال شد ",
            icon: "success",
            button: "!باشه",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  // تبدیل skills به آرایه برای نمایش
  const skillsList =
    typeof skills === "string"
      ? skills.split("\n").filter((s) => s.trim() !== "")
      : Array.isArray(skills)
      ? skills
      : [];

  return (
    <>
      {title.length > 0 ? (
        <div className={styles.singleJob}>
          <Header title="موقعیت شغلی" />

          <div className={styles.singleJobBody}>
            <div className={styles.singleTopCard}>
              <div className={styles.cardTop}>
                <div className={styles.TopDate}>
                  <p>فرصت: {deadline} روز</p>
                  <AiOutlineFieldTime />
                </div>
                <div className={styles.TopImg}>
                  <img src={work} alt="JobSearch" />
                </div>
              </div>

              {title_fa && <h4>{title_fa}</h4>}
              <h4>{title}</h4>

              <div className={styles.cardText}>
                <p>
                  <IoLocationOutline /> شهر: {city}
                </p>
                <p>
                  <IoLocationOutline /> شرکت: {company}
                </p>
                <p>
                  <BsGlobe /> کشور: {country}
                </p>
                <p>
                  حقوق دریافتی: {salary} <TbCurrencyDollar />
                </p>
              </div>

              <div className={styles.cardBtns}>
                <button
                  className={styles.cardBtn2}
                  type="button"
                  onClick={send}
                  disabled={loader}
                >
                  رزومه ات رو بفرست
                </button>

                <button
                  className={styles.cardBtn1}
                  type="button"
                  onClick={paymentCheck}
                  disabled={loading}
                >
                  لینک اصلی رو ببین
                </button>
              </div>
            </div>

            <div className={styles.singleBottomCard}>
              <div className={styles.bottomCardTitle}>
                <h2>مدارک مورد نیاز</h2>
                <div></div>
              </div>
              <p>{document}</p>
            </div>

            <div className={styles.singleBottomCard}>
              <div className={styles.bottomCardTitle}>
                <h2>مسئولیت ها</h2>
                <div></div>
              </div>
              <p>{responsibility}</p>
            </div>

            <div className={styles.singleBottomCard}>
              <div className={styles.bottomCardTitle}>
                <h2>مهارت‌ها</h2>
                <div></div>
              </div>
              <ul className={styles.skillsList}>
                {skillsList.length > 0 ? (
                  skillsList.map((skill, index) => (
                    <li key={index}>{skill}</li>
                  ))
                ) : (
                  <li>مهارتی ثبت نشده</li>
                )}
              </ul>
            </div>
          </div>

          <Footer active="job" />
        </div>
      ) : (
        <div className="spinner">
          <Loader
            type="TailSpin"
            color="rgb(236, 177, 28)"
            height={80}
            width={80}
          />
        </div>
      )}
    </>
  );
}

export default SingleJob;